import api from "./index";

export const request = (path: string, data: Object = {}, signal?: AbortSignal) =>
  api.post("/wp-json/custom-api/v1/user-info", {
    uri_path: path,
    params: {
      ...data,
    }
  }, {
    signal
  });
